export var EmployeeGroupsType;
(function (EmployeeGroupsType) {
    EmployeeGroupsType["Detractor"] = "Detractor";
    EmployeeGroupsType["Passive"] = "Passive";
    EmployeeGroupsType["Promoter"] = "Promoter";
})(EmployeeGroupsType || (EmployeeGroupsType = {}));
